import { render, staticRenderFns } from "./kb-article.vue?vue&type=template&id=49d2bb6b&scoped=true&"
import script from "./kb-article.vue?vue&type=script&lang=js&"
export * from "./kb-article.vue?vue&type=script&lang=js&"
import style0 from "./kb-article.vue?vue&type=style&index=0&id=49d2bb6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d2bb6b",
  null
  
)

export default component.exports